/**
 * Says what the scheduler on this deployment will actually do, where schedules
 * are made (REG-05). It reads the switches; it changes nothing.
 */
import { Info } from 'lucide-react'
import { useSchedulerStatus } from './schedulerStatus'

export function SchedulerStatusNotice({ compact = false }: { compact?: boolean }) {
  const { data } = useSchedulerStatus()
  if (!data || (data.generationEnabled && data.deliveryEnabled)) return null
  return (
    <div
      role="status"
      data-testid="scheduler-status-notice"
      className={`flex items-start gap-2 rounded border border-amber-400/30 bg-amber-400/[0.06] text-amber-100/90 ${
        compact ? 'px-2.5 py-1.5 text-[10px]' : 'px-3 py-2 text-[11px]'
      }`}
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-300" aria-hidden />
      <span>{data.summary}</span>
    </div>
  )
}
